import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-cielo-footer',
  templateUrl: './cielo-footer.component.html',
  styleUrls: ['./cielo-footer.component.scss']
})
export class CieloFooterComponent implements OnInit {
  @Input() scope;
  constructor() {}
  ngOnInit(): void {}
}
